import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class AddToCartMoreThanInStockApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.AddToCartMoreThanInStock;

  constructor(private productName: string) {
  }

  getPayload(): any {
    return {
      productName: this.productName,
    };
  }
}
